import { VehicleBox, VehicleInfo } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'

type VehicleInfoInput = Partial<Omit<VehicleInfo, 
  'id' |
  'created_at' |
  'updated_at' |
  'type' |
  'courierShifts' |
  'vehicleIncidents' |
  'boxes'
>> & {
  id?: GQL_ID
  boxes?: Omit<VehicleBox, 'id'>[]
}

type Variables = {
  newData: VehicleInfoInput
  upsert: boolean
}

type Mutation = {
  updateVehicle: VehicleInfo
}

export const GQL_MUTATION_UPDATE_VEHICLE_INFO = gql`
  mutation updateVehicle($newData: VehicleInfoInput!, $upsert: Boolean) {
    updateVehicle(newData: $newData, upsert: $upsert) {
      id
      type {
        id
        name
        code
        description
      }
      vehicle_type_id
      license_plate
      vin
      brand
      model
      year
      color
      capacity_kg
      capacity_m3
      temp_min_c
      temp_max_c
      range_km
      average_speed
      is_active
      comment

      boxes {
        id
        name
        number
        vehicle_id
        sort_order
        special_conditions
      }
    }
  }
`

export const useMutateUpdateVehicleInfo = () => useMutation<Mutation, Variables>(GQL_MUTATION_UPDATE_VEHICLE_INFO, {
  refetchQueries: [ 'allVehicles' ]
})